// extracted by mini-css-extract-plugin
export default {"settingUnitWrapper":"ConfigModifierComp_settingUnitWrapper__RDwxi","switchRoot":"ConfigModifierComp_switchRoot__5rWGh","switchThumb":"ConfigModifierComp_switchThumb__z+EZf"};